'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

export async function deleteCustomVoice(
  voiceId: string,
): Promise<ActionResult<{ voiceId: string }>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const { VoiceCloneService } = await import(
      '@/contexts/ai/services/generation/VoiceCloneService'
    );
    const { VoiceSampleStorage } = await import(
      '@/contexts/media/storage/VoiceSampleStorage'
    );

    const voiceSampleStorage = new VoiceSampleStorage();
    const voiceCloneService = new VoiceCloneService(voiceSampleStorage);

    await voiceCloneService.deleteCustomVoice(familyId, voiceId);

    // Emit SSE so all connected clients update their voice lists
    const { getEventBus } = await import('@/shared/infrastructure/events/eventBus');
    const { EVENT_TYPES } = await import('@/shared/infrastructure/events/eventTypes');
    getEventBus().emit({
      type: EVENT_TYPES.VOICE.DELETED,
      familyId,
      payload: { voiceId, familyId },
    });

    return { success: true, data: { voiceId } };
  } catch (e: unknown) {
    actionErrorLog('deleteCustomVoice', e);
    const message = e instanceof Error ? e.message : 'Failed to delete voice';
    return { success: false, error: message };
  }
}
